import React, { useEffect, useState } from 'react';
import Button from '../components/ui/button';
import { FaTools, FaUserFriends, FaLock } from 'react-icons/fa';

const Home = () => {
  const isAuthenticated = !!localStorage.getItem('token'); // Check login status
  const [leadsCount, setLeadsCount] = useState(1200);
  const [usersCount, setUsersCount] = useState(450);

  useEffect(() => {
    const interval = setInterval(() => {
      setLeadsCount((prev) => prev + 1); // Simulate real-time counter for leads
      setUsersCount((prev) => prev + 1); // Simulate real-time counter for users
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      {/* Header Section */}
      <header className="bg-blue-600 text-white py-6 px-8 flex justify-between items-center">
        <h1 className="text-3xl font-bold">Home Lead IQ</h1>
        {isAuthenticated && (
          <nav className="flex space-x-6">
            <a href="/dashboard" className="hover:underline">
              Dashboard
            </a>
            <a href="/leads" className="hover:underline">
              Leads
            </a>
            <a href="/analytics" className="hover:underline">
              Analytics
            </a>
            <a href="/settings" className="hover:underline">
              Settings
            </a>
          </nav>
        )}
        {!isAuthenticated && (
          <div className="flex space-x-4">
            <Button
              onClick={() => (window.location.href = '/signup')}
              className="bg-white text-blue-600 px-4 py-2 rounded-lg font-semibold hover:bg-blue-100"
            >
              Sign Up
            </Button>
            <Button
              onClick={() => (window.location.href = '/login')}
              className="bg-white text-blue-600 px-4 py-2 rounded-lg font-semibold hover:bg-blue-100"
            >
              Login
            </Button>
          </div>
        )}
      </header>

      {/* Hero Section with Counters */}
<section className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-20 px-8 text-center relative">
  <div className="absolute inset-0">
    <canvas id="particleCanvas" className="w-full h-full"></canvas>
  </div>
  <h1 className="text-4xl font-bold mb-4 relative">
    Revolutionizing Mortgage Tools for Loan Officers
  </h1>
  <p className="text-lg mb-6 relative">
    Streamline your leads, calls, and emails—all in one platform. Simplify your workflow and boost productivity!
  </p>
  <div className="flex justify-center space-x-12 mb-6 relative">
    <div className="text-center">
      <h2 className="text-3xl font-bold">{leadsCount}+</h2>
      <p>Leads Managed</p>
    </div>
    <div className="text-center">
      <h2 className="text-3xl font-bold">{usersCount}+</h2>
      <p>Happy Users</p>
    </div>
  </div>
  <p className="text-lg mb-6 font-semibold relative">
    Trusted by <span className="font-bold">{usersCount}+</span> professionals!
  </p>
  <Button
    onClick={() => (window.location.href = '/signup')} // Redirect to Sign Up page
    className="bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold shadow-lg hover:bg-blue-50 hover:shadow-xl transition animate-pulse"
  >
    Get Started for $99
  </Button>
</section>

      {/* Features Section */}
      <section className="py-12 px-8 bg-gray-50">
        <h2 className="text-2xl font-bold mb-6 text-center">Why Choose Home Lead IQ?</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div>
            <FaTools className="text-blue-600 text-4xl mb-4" />
            <h3 className="text-xl font-bold mb-2">Comprehensive Tools</h3>
            <p>Manage leads, track analytics, and streamline communication with our all-in-one platform.</p>
          </div>
          <div>
            <FaUserFriends className="text-blue-600 text-4xl mb-4" />
            <h3 className="text-xl font-bold mb-2">User-Friendly Interface</h3>
            <p>Simple and intuitive design to help you focus on what matters most—closing deals.</p>
          </div>
          <div>
            <FaLock className="text-blue-600 text-4xl mb-4" />
            <h3 className="text-xl font-bold mb-2">Secure and Reliable</h3>
            <p>Advanced security features to protect your data and ensure seamless performance.</p>
          </div>
        </div>
      </section>

      {/* Dashboard Preview Section */}
      <section className="py-12 px-8 bg-gradient-to-r from-gray-50 to-gray-100">
        <h2 className="text-2xl font-bold text-center mb-6">Preview Our Dashboard</h2>
        <p className="text-center mb-8">Get an inside look at how Home Lead IQ makes lead management easy and efficient.</p>
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200">
          <div className="bg-gray-100 py-2 px-4 flex justify-between items-center border-b">
            <div className="flex space-x-2">
              <div className="w-3 h-3 bg-red-500 rounded-full"></div>
              <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
              <div className="w-3 h-3 bg-green-500 rounded-full"></div>
            </div>
            <p className="text-gray-500 text-sm">Dashboard Preview</p>
          </div>
          <div className="h-96 overflow-y-scroll p-4">
            <img
              src="/path-to-your-dashboard-screenshot.jpg"
              alt="Interactive Dashboard Preview"
              className="w-full rounded-lg"
            />
          </div>
        </div>
      </section>

      {/* Pricing Table Section */}
      <section className="py-12 px-8 bg-gray-100">
        <h2 className="text-2xl font-bold text-center mb-6">Pricing Comparison</h2>
        <div className="overflow-x-auto">
          <table className="table-auto mx-auto border-collapse border border-gray-300 w-full max-w-4xl text-left">
            <thead>
              <tr className="bg-blue-600 text-white">
                <th className="px-4 py-2">Features</th>
                <th className="px-4 py-2">Home Lead IQ</th>
                <th className="px-4 py-2">Competitor A</th>
                <th className="px-4 py-2">Competitor B</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border px-4 py-2">Price</td>
                <td className="border px-4 py-2">$99/month</td>
                <td className="border px-4 py-2">$149/month</td>
                <td className="border px-4 py-2">$199/month</td>
              </tr>
              <tr>
                <td className="border px-4 py-2">Lead Management</td>
                <td className="border px-4 py-2">✅</td>
                <td className="border px-4 py-2">✅</td>
                <td className="border px-4 py-2">✅</td>
              </tr>
              <tr>
                <td className="border px-4 py-2">Real-Time Lead Scoring</td>
                <td className="border px-4 py-2">✅</td>
                <td className="border px-4 py-2">❌</td>
                <td className="border px-4 py-2">❌</td>
              </tr>
              <tr>
                <td className="border px-4 py-2">Mobile App</td>
                <td className="border px-4 py-2">✅</td>
                <td className="border px-4 py-2">❌</td>
                <td className="border px-4 py-2">❌</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Lead Capture Form */}
      <section id="signup-section" className="bg-gray-100 py-12 px-8 text-center">
        <h2 className="text-2xl font-bold mb-4">Request a Demo</h2>
        <p className="mb-6">
          Learn how Home Lead IQ can transform your business. Submit your info, and we'll reach out!
        </p>
        <form className="max-w-lg mx-auto">
          <div className="mb-4">
            <input
              type="text"
              placeholder="Name"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="mb-4">
            <input
              type="email"
              placeholder="Email"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="mb-4">
            <input
              type="tel"
              placeholder="Phone Number"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="mb-6">
            <textarea
              placeholder="Message (Optional)"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows="4"
            ></textarea>
          </div>
          <button
            type="submit"
            className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
          >
            Submit
          </button>
        </form>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-6 px-8 text-center">
        <p>
          © 2025 Home Lead IQ. All rights reserved. |{' '}
          <a href="/terms-of-service" className="underline">
            Terms of Service
          </a>{' '}
          |{' '}
          <a href="/privacy-policy" className="underline">
            Privacy Policy
          </a>
        </p>
      </footer>
    </div>
  );
};

export default Home;
